import React from 'react'
import { Link } from 'react-router-dom'
import Header from '../../headerone/Main'
import Breadcrumb from '../../Breadcrumb/Main'
import {  Row, Col } from 'react-bootstrap';

const Coordinators = [

    
        {
            "Name": "Prof. N N Murty",
            "Post": "Dean of Student Affairs",
            "Position": "Professor",
            "Category": "Electrical Engineering",
            "Phone": "0877 250 3035",
            "Email": "nnmurty@iittp.ac.in",
            "Image": "https://files.iittp.ac.in/images/demo/iit/nnmurthy.jpg"
            
        },
        {
            "Name": "Dr. Prasanna V Sampath",
            "Post": "Chair, Council of Wardens IITT",
            "Position": "Assistant Professor",
            "Category": "Civil & Environmental Engineering",
            "Phone": "0877 250 3162",
            "Email": "prasvenk@iittp.ac.in",
            "Image": "https://files.iittp.ac.in/images/demo/iit/venkatpv.jpg"
        },
        {
            "Name": "Dr. Srijanani Anurag Prasad",
            "Post": "Associate Professor",
            "Position": "Department of Mathematics and Statistics",
            "Category": "",
            "Phone": "0877 250 3360",
            "Email": "srijanani@iittp.ac.in",
            "Image": "https://files.iittp.ac.in/images/demo/iit/srijanani.jpg"
        },
        {
            "Name": "Dr. Narasamma Nippatlapalli",
            "Post": "Assistant Professor",
            "Position": "Civil & Environmental Engineering",
            "Category": "",
            "Phone": "0877 250",
            "Email": "nippatlapallice@iittp.ac.in",
            "Image": "https://files.iittp.ac.in/images/demo/iit/Narasamma.png"
        },
        {
            "Name": "Dr. Brindha Moorthy",
            "Post": "Assistant Professor",
            "Position": "Chemical Engineering",
            "Category": "",
            "Phone": "0877 250",
            "Email": "brindha.m@iittp.ac.in",
            "Image": "https://files.iittp.ac.in/images/demo/iit/Dr.Brindha_Moorthy_AP.jpg"
        },
        {
            "Name": "Dr. Aravinda S",
            "Post": "Associate Professor",
            "Position": "Physics Department",
            "Category": "",
            "Phone": "0877 250",
            "Email": "aravinda@iittp.ac.in",
            "Image": "https://files.iittp.ac.in/images/demo/iit/Arv.JPG"
        }
    

]
const Volunteers = [
    {
        "Name": "Ms. Tanvi Gupta",
        "Degree": "2nd year",
        "Category": "Civil & Environmental Engineering",
        "RollNo": "CE22B035",
        "Image": "https://files.iittp.ac.in/images/demo/iit/helpdesk/2023/Tanvi_Gupta.png"
    },
    {
        "Name": "Ms. Palak Khandelwal",
        "Degree": "2nd year",
        "Category": "Chemical Engineering",
        "RollNo": "CH22B026",
        "Image": "https://files.iittp.ac.in/images/demo/iit/helpdesk/2023/Palak_Khandelwal.png"
    },
    {
        "Name": "Ms. P. Snehitha",
        "Degree": "2nd year",
        "Category": "Computer Science and Engineering",
        "RollNo": "CS22B041",
        "Image": "https://files.iittp.ac.in/images/demo/iit/helpdesk/2023/P_Snehitha.png"
    },
    {
        "Name": "Ms. B. G. P Sahithi",
        "Degree": "2nd year",
        "Category": "Electrical Engineering",
        "RollNo": "EE22B006",
        "Image": "https://files.iittp.ac.in/images/demo/iit/helpdesk/2023/B.G.P_Sahithi.png"
    },
    {
        "Name": "Ms. Roshini budumuru",
        "Degree": "3rd year",
        "Category": "Mechanical Engineering",
        "RollNo": "ME21B038",
        "Image": "https://files.iittp.ac.in/images/demo/iit/helpdesk/2023/Roshini_budumuru.png"
    }



]

function Main() {

    return (
        <>
            <Header />
            <Breadcrumb title="Home" subtitle="Help Desk" />
            <section className="team-area fix p-relative pt-120 pb-80" >
                 

                <div className="row">
                    <div className="col-lg-12 p-relative">
                        <div className="section-title center-align mb-50 text-center wow fadeInDown animated" data-animation="fadeInDown" data-delay=".4s">
                            <h5>
                                <i className="fal fa-graduation-cap me-3 mb-4" />Help Desk for Prospective Girl Student
                            </h5>
                            <h5 className='text-dark'>IIT Tirupati welcomes female rank-holders in JEE (Advanced) 2023.</h5>

                        </div>
                        
                    </div>
                    
                </div>

                <div className="container">

                    <p>IIT Tirupati has constantly been attracting a large number of girl students since its inception in the year 2015. <span className='c-link'> IIT Tirupati has 24% girl students as on date , highest among all the IIT's.</span> The Institute has formed a special guidance team to provide necessary information and guidance to prospective girl students who have cleared JEE Advanced 2023. Please feel free to contact any of our faculty coordinators/volunteers, whose details are given below.</p>
                    <Row>
               
                        <Col md={12} className='c-right'>

                            {/*--------------------------- Head of the dept */}
                            <h3 className='c-headline mt-5 mb-5'>Coordinators</h3>
                            <div className="row justify-content-center">
                                
                                {Coordinators.map((Coordinators, index) => (
                                    <div key={index} className="col-xl-4 col-md-6">
                            

                                        <div className={`single-team mb-40 ${index == 0 ? "c-highlight" : ""}`}>
                                            <div className="team-thumb">
                                                <div className="brd">
                                                    <Link to={Coordinators.NameLink}>
                                                        <img src={Coordinators.Image} alt="img" />
                                                    </Link>
                                                </div>
                                            </div>
                                            <div className="team-info">
                                                <h4>
                                                    {Coordinators.Name}
                                                </h4>
                                                <p className='text-dark'>{Coordinators.Post}</p>

                                                <div className="text-dark c-lineheight2">
                                                    <p > <i className="fal fa-graduation-cap me-2" />{Coordinators.Position}</p>
                                                    <p className="text-dark">{Coordinators.Category}</p>
                                                    

                                                    {(Coordinators.Phone !== undefined && Coordinators.Phone !== "") && (
                                                        <p className="text-dark"><i className="fal fa-phone-alt me-2"></i>{Coordinators.Phone}</p>
                                                    )}
                                                    <p className="text-dark"><i className="fal fa-envelope  me-1"></i> Email : {Coordinators.Email}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            {/*--------------------------- Volunteers*/}
                            <div className="row">
                                <h3 className='c-headline mt-5 mb-5'>Volunteers</h3>
                                {Volunteers.map((Volunteers, index) => (
                                    <div key={index} className="col-xl-4 col-md-6">
                                        <div className={`single-team mb-40 ${index == 0 ? "c-highlight" : ""}`}>
                                            <div className="team-thumb">
                                                <div className="brd">
                                               
                                                        <img src={Volunteers.Image} alt="img" />
                                               
                                                </div>
                                            </div>
                                            <div className="team-info">
                                                <h4>
                                                    <Link to={Volunteers.NameLink}>{Volunteers.Name}</Link>
                                                </h4>

                                                <div className="text-dark c-lineheight2">
                                                    <p className="text-dark">{Volunteers.Degree}</p>
                                                    <p > <i className="fal fa-graduation-cap me-2" />{Volunteers.Category}</p>
                                                    <p className="text-dark">Roll No: {Volunteers.RollNo}</p>
                                                  

                                                  
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </Col>
                    </Row>
                </div>
            </section>
        </>
    )
}

// // Function to parse HTML content and extract text
// function parseHTML(htmlString) {
//     const tempElement = document.createElement('div');
//     tempElement.innerHTML = htmlString;
//     return tempElement.textContent || tempElement.innerHTML || '';
// }


export default Main